import { combineReducers } from "redux";
import { willsReducer } from "@willsStore/resources/willsReducer";

const resourcesReducer = combineReducers({
  wills: willsReducer,
});

export default resourcesReducer;
